// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"395b9036","732":"6ac2cb1d","977":"f801b90f"}[chunkId] + ".chunk.js";
};